import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MyView from '../views/MyView.vue'
import BuyVipView from '../views/BuyVipView.vue'
import store from "@/store/index"
import api from "@/utils/api"
Vue.use(VueRouter)
const routes = [
	{
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		path: '/auth',
		name: 'auth',
		component: (resolve) => require(['@/views/Authorization.vue'], resolve),
	},
	{
		path: '/my',
		name: 'my',
		component: MyView
	},
	{
		path: '/buyvip',
		name: 'buyvip',
		component: BuyVipView
	},
	{
		path: '/myorder',
		name: 'myorder',
		component: (resolve) => require(['@/views/MyOrder.vue'], resolve),
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: (resolve) => require(['@/views/Agreement.vue'], resolve),
		meta: {
			title: 'MedliveGPT用户体验规则'
		}
	},
	
	{
		path: '/newchat',
		name: 'newchat',
		component: (resolve) => require(['@/views/NewChat.vue'], resolve),
	}
]

const router = new VueRouter({
	mode: 'history',
	base: '/web/',
	routes
})

export default router

router.beforeEach(async (to, from, next) => {
	console.log(to, window.location,'--------->')
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	if (to.query.token) {
		let params = {
			token: to.query.token
		}
		api.appLogin(params).then((res) => {
			console.log(res,'---------')
			delete to.query.token
			window.localStorage.setItem('token', res.data)
			window.location.replace('/web/')
		}).catch(e=>{
			console.log(e)
		})
	} else {
		let token = window.localStorage.getItem('token')
		if (!token && to.name != 'auth') {
			next({
				name: 'auth',
				query:{
					redirectURL:encodeURIComponent(to.fullPath)
				}
				// path: `auth?redirectURL=${encodeURIComponent(to.path)}`,
			})
		}
		if (token && to.name != 'auth') {
			try {
				let params = {
					token: window.localStorage.getItem('token')
				}
				api.userInfo(params).then((res) => {
					store.commit('setUserInfo', JSON.stringify(res.data))
				})
			} catch (e) {
				console.log(e)
			}
		}
		next()
	}
});